import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase URL eller anon key saknas för live-scorekortet."
  );
}

/*
 * Scorekortslänkar använder en separat Supabase-klient.
 * Därmed påverkas inte administratörens vanliga inloggning.
 */
export const liveSupabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      storageKey: "holeinone-live-scorecard-auth-v1",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
  }
);